export default __webpack_public_path__ + "static/media/portatamboreslinga.22819fb0.png";